import "../../../styles/BlogPost/BlogPosts.css";
import "../../../styles/BlogPost/BlogCard.css";

import BlogCard from "./BlogCard";
import Button from "../../atoms/Button";
import Label from "../../atoms/Label";
import React from "react";
import { useNavigate } from "react-router-dom";
const BlogPosts = ({ posts = [] }) => {
	const navigate = useNavigate();
	return (
		<div className='blog-container'>
			<Label
				style={{
					width: "100%",
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-start",
					marginBottom: "45px",
				}}
				label={"Blog Posts"}
				fontSize={"40px"}
				color={"#000000"}
				fontWeight={"700"}
				textAlign='left'
			/>
			<div className='blog-grid'>
				{posts?.map((blog) => (
					<BlogCard key={blog.Blog_ID} id={blog.Blog_ID} title={blog.Blog_Title} description={blog.description} date={blog.createdOn} image={blog.image} />
				))}
			</div>
			<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
				<Button
					className='read-more-button'
					label={"Read More Blogs"}
					onClick={() => {
						navigate("/blog");
					}}
					style={{
						padding: "10px 20px",
						backgroundColor: "#1F21E6",
						color: "white",
						border: "none",
						borderRadius: "5px",
						cursor: "pointer",
						marginTop: "20px",
					}}
				/>
			</div>
		</div>
	);
};

export default BlogPosts;
